module.exports = __webpack_public_path__ + "d0b9cdfbfc019debe09ed13b672b74de.png";